export default `

.RichEditor-root {
    background: #fff;
    border: 1px solid #ddd;
    /* font-family: 'Georgia', serif; */
    font-size: 14px;
    padding: 15px;
  }
  
  .RichEditor-editor {
    cursor: text;
    font-size: 16px;
    margin-top: 10px;
  }
  
  .RichEditor-editor .public-DraftEditorPlaceholder-root,
  .RichEditor-editor .public-DraftEditor-content {
    margin: 0 -15px -15px;
    padding: 15px;
  }
  
  .RichEditor-editor .public-DraftEditor-content {
    min-height: 250px;
  }
  
  .RichEditor-hidePlaceholder .public-DraftEditorPlaceholder-root {
    display: none;
  }
  
  .RichEditor-editor .RichEditor-blockquote {
    border-left: 5px solid #eee;
    color: #666;
    /* font-family: 'Hoefler Text', 'Georgia', serif; */
    font-style: italic;
    margin: 16px 0;
    padding: 10px 20px;
  }
  
  .RichEditor-editor .public-DraftStyleDefault-pre {
    background-color: rgba(0, 0, 0, 0.05);
    /* font-family: 'Inconsolata', 'Menlo', 'Consolas', monospace; */
    font-size: 16px;
    padding: 20px;
  }
  
  .RichEditor-controls {
    /* font-family: 'Helvetica', sans-serif; */
    font-size: 14px;
    margin-bottom: 5px;
    user-select: none;
    vertical-align: middle;
  }
  
  .RichEditor-styleButton {
    color: #999;
    cursor: pointer;
    margin-right: 16px;
    padding: 2px 0;
    display: inline-block;
  }
  
  .RichEditor-activeButton {
    color: #5890ff;
  }

  .DraftEditor-editorContainer {
    font-size: inherit;
  }

  .headerStyleDropdown {
    padding-right: 10px;
  }

  h1 {
    font-size: 1.8em !important;
  }

  /* Editor Plugins */
  /* Anchor */

  .draftJsMentionPlugin__input__1Wxng {
    height: 34px;
    width: 220px;
    padding: 0 12px;
    font-size: 15px;
    font-family: inherit;
    background-color: transparent;
    border: none;
    color: #444;
  }
  
  .draftJsMentionPlugin__input__1Wxng:focus {
    outline: none;
  }
  
  .draftJsMentionPlugin__input__1Wxng::-webkit-input-placeholder {
    color: #888;
  }
  
  .draftJsMentionPlugin__input__1Wxng:-ms-input-placeholder {
    color: #888;
  }
  
  .draftJsMentionPlugin__input__1Wxng::placeholder {
    color: #888;
  }
  
  .draftJsMentionPlugin__inputInvalid__X9hHv {
    color: #e65757;
  }
  
  .draftJsMentionPlugin__link__TQHAX {
    color: #2996da;
    text-decoration: underline;
  }

  .draftJsToolbar__buttonWrapper__1Dmqh {
    display: inline-block;
  }
  
  .draftJsToolbar__button__qi1gf {
    background: #fbfbfb;
    color: #888;
    font-size: 18px;
    border: 0;
    padding-top: 5px;
    vertical-align: bottom;
    height: 34px;
    width: 36px;
  }
  
  .draftJsToolbar__button__qi1gf svg {
    fill: #888;
  }
  
  .draftJsToolbar__button__qi1gf:hover, .draftJsToolbar__button__qi1gf:focus {
    background: #f3f3f3;
    outline: 0; /* reset for :focus */
  }
  
  .draftJsToolbar__active__3qcpF {
    background: #efefef;
    color: #444;
  }

.draftJsMentionPlugin__iframe__stjRT {
    height: 480px !important; 
    width: 854px !important;
}

.draftJsMentionPlugin__iframeContainer__21EVZ {
    text-align: center;
}
  
  .draftJsToolbar__active__3qcpF svg {
    fill: #444;
  }
  .draftJsToolbar__separator__3U7qt {
    display: inline-block;
    border-right: 1px solid #ddd;
    height: 24px;
    margin: 0 0.5em;
  }
  .draftJsToolbar__toolbar__dNtBH {
    left: 50%;
    -webkit-transform: translate(-50%) scale(0);
            transform: translate(-50%) scale(0);
    position: absolute;
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0px 1px 3px 0px rgba(220,220,220,1);
    z-index: 2;
    box-sizing: border-box;
  }
  
  .draftJsToolbar__toolbar__dNtBH:after, .draftJsToolbar__toolbar__dNtBH:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  
  .draftJsToolbar__toolbar__dNtBH:after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #fff;
    border-width: 4px;
    margin-left: -4px;
  }
  .draftJsToolbar__toolbar__dNtBH:before {
    border-color: rgba(221, 221, 221, 0);
    border-top-color: #ddd;
    border-width: 6px;
    margin-left: -6px;
  }
  
  .draftJsFocusPlugin__unfocused__1Wvrs:hover {
    cursor: default;
    border-radius: 2px;
    box-shadow: 0 0 0 3px #D2E3F7;
  }
  
  .draftJsFocusPlugin__focused__3Mksn {
    cursor: default;
    border-radius: 2px;
    box-shadow: 0 0 0 3px #ACCEF7;
  }

  .draftJsEmojiPlugin__alignmentTool__2mkQr {
    left: 50%;
    -webkit-transform: translate(-50%) scale(0);
            transform: translate(-50%) scale(0);
    position: absolute;
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0px 1px 3px 0px rgba(220,220,220,1);
    z-index: 2;
    box-sizing: border-box;
  }
  
  .draftJsEmojiPlugin__alignmentTool__2mkQr:after, .draftJsEmojiPlugin__alignmentTool__2mkQr:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  
  .draftJsEmojiPlugin__alignmentTool__2mkQr:after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #fff;
    border-width: 4px;
    margin-left: -4px;
  }
  .draftJsEmojiPlugin__alignmentTool__2mkQr:before {
    border-color: rgba(221, 221, 221, 0);
    border-top-color: #ddd;
    border-width: 6px;
    margin-left: -6px;
  }
  .draftJsEmojiPlugin__buttonWrapper__1Dmqh {
    display: inline-block;
  }
  
  .draftJsEmojiPlugin__button__qi1gf {
    background: #fbfbfb;
    color: #888;
    font-size: 18px;
    border: 0;
    padding-top: 5px;
    vertical-align: bottom;
    height: 34px;
    width: 36px;
  }
  
  .draftJsEmojiPlugin__button__qi1gf svg {
    fill: #888;
  }
  
  .draftJsEmojiPlugin__button__qi1gf:hover, .draftJsEmojiPlugin__button__qi1gf:focus {
    background: #f3f3f3;
    outline: 0; /* reset for :focus */
  }
  
  .draftJsEmojiPlugin__active__3qcpF {
    background: #efefef;
    color: #444;
  }
  
  .draftJsEmojiPlugin__active__3qcpF svg {
    fill: #444;
  }

  // .draftJsMentionPlugin__iframeContainer__21EVZ {
  //   width: 100%;
  //   height: 0;
  //   position: relative;
  //   padding-bottom: 56.25%;
  // }
  
  // .draftJsMentionPlugin__iframe__stjRT {
  //   width: 100%;
  //   height: 100%;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
  
  .draftJsMentionPlugin__invalidVideoSrc__3dIji {
    text-align: center;
    background-color: #eaeaea;
    padding: 1em;
  }
    
  .post-button-container {
    display: flex;
    justify-content: flex-start;
    margin-left: auto;
  }

  .editorControls-container {
    border-bottom: 1px solid #e8e8e8;
    background: white;
  }

  .editorControls-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0px;
  }
  
  `


// WEBPACK FOOTER //
// ./src/components/docs/editor.css.js